/**
 * Shared state for the desktop Twitter GraphQL client.
 * This module deliberately avoids server-only dependencies so it can be imported from client code.
 */

interface DesktopGraphQLState {
  cachedClient: unknown;
  initializingClient: Promise<unknown> | null;
}

const stateKey = '__sweetisticsDesktopGraphQL';

const globalState = globalThis as typeof globalThis & {
  [stateKey]?: DesktopGraphQLState;
};

function ensureState(): DesktopGraphQLState {
  let existing: DesktopGraphQLState | undefined = globalState[stateKey];
  if (!existing) {
    existing = {
      cachedClient: null,
      initializingClient: null,
    } satisfies DesktopGraphQLState;
    globalState[stateKey] = existing;
  }
  return existing;
}

export function getCachedClient(): unknown {
  return ensureState().cachedClient;
}

export function setCachedClient(client: unknown): void {
  ensureState().cachedClient = client ?? null;
}

export function getInitializingClient(): Promise<unknown> | null {
  return ensureState().initializingClient ?? null;
}

export function setInitializingClient(promise: Promise<unknown> | null): void {
  ensureState().initializingClient = promise ?? null;
}

export function resetDesktopGraphQLClient(): void {
  const state = ensureState();
  state.cachedClient = null;
  state.initializingClient = null;
}
